import { FC } from 'react'

import { useAccountContext } from 'components/contexts/AccountContext'
import { UPGRADE_CTA_QUERY_SELECTOR, usePendoModalMutationObserver } from 'hooks/usePendoModalMutationObserver'
import upgrade from 'utils/fetchPendo'

const PendoProvider: FC = ({ children }) => {
  const { orgId } = useAccountContext()

  usePendoModalMutationObserver({
    upgradeCtaSelector: UPGRADE_CTA_QUERY_SELECTOR,
    onCtaClick: ({ campaignId }) => {
      upgrade(orgId, campaignId)
    },
  })

  return <>{children}</>
}

export default PendoProvider
